import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  makeVar,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";



const TOKEN = "TOKEN";
const NAME = "NAME";

export const isLoggedInVar = makeVar(Boolean(localStorage.getItem(TOKEN)));
export const setbuttonon = makeVar(0);
//export const SERVERURL = "http://www.roomartist.kr:29000"
export const SERVERURL = "https://www.yooniverseenglish.co.kr"
export const logUserIn = ({token,name}) => {
  localStorage.setItem(TOKEN, token);
  localStorage.setItem(NAME, name);

  isLoggedInVar(true);
};

export const logUserOut = () => {
  localStorage.removeItem(TOKEN);
  localStorage.removeItem(NAME);
  window.location.reload();
};

const onErrorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.log(`GraphQL Error`, graphQLErrors);
  }
  if (networkError) {
    console.log("Network Error", networkError);
  }
});

const httpLink = createHttpLink({
 uri:SERVERURL +"/graphql",  
 // uri:"http://ec2-3-38-74-212.ap-northeast-2.compute.amazonaws.com:4005/graphql",  
});




const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      token: localStorage.getItem(TOKEN),
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(onErrorLink).concat(httpLink),
  cache: new InMemoryCache(),
});